export const SQUAD_SECTION_LABELS = {
  coach: {
    key: 'eventodeportivo_paises_fichasuperior_texto_titulo_entrenador',
    length: 34,
  },
  goalkeeper: {
    key: 'eventodeportivo_paises_fichasuperior_texto_titulo_portero',
    length: 34,
  },
  defenders: {
    key: 'eventodeportivo_paises_fichasuperior_texto_titulo_defensa',
    length: 34,
  },
  midfielders: {
    key: 'eventodeportivo_paises_fichasuperior_texto_titulo_Mediocampista',
    length: 34,
  },
  forwards: {
    key: 'eventodeportivo_paises_fichasuperior_texto_titulo_Defensa',
    length: 34,
  },
};

export const SQUAD_TOGGLE_LABEL = {
  label: { key: 'eventodeportivo_paises_texto_titulo_verplantillacompleta' },
};

export const SQUAD_EMPTY_LABEL = {
  label: { key: 'eventodeportivo_pais_texto_sininfoplantilla', length: 22 },
};

export const SQUAD_LAST_LINEUP_LABEL = {
  label: {
    key: 'eventodeportivo_paises_fichasuperior_texto_titulo_ultimalineacion',
    length: 24,
  },
};

export const SQUAD_MATCH_LABEL = {
  label: {
    key: 'eventodeportivo_paises_fichasuperior_texto_titulo_partido',
    length: 20,
  },
};
